import { SidebarBody, type NavSection } from '@strivelabs/ui-blocks/v2';

/**
 * The Workspace tab. `SidebarBody` picks the nav tree or the icon rail from the
 * collapsed state, so this stays a single line.
 */
export function WorkspaceTab({ sections }: { sections: NavSection[] }) {
  return <SidebarBody sections={sections} />;
}
